import { render, staticRenderFns } from "./MeitavOpportunisticSavingInsight.vue?vue&type=template&id=1a4cbb6c&scoped=true"
import script from "./MeitavOpportunisticSavingInsight.vue?vue&type=script&lang=js"
export * from "./MeitavOpportunisticSavingInsight.vue?vue&type=script&lang=js"
import style0 from "./MeitavOpportunisticSavingInsight.vue?vue&type=style&index=0&id=1a4cbb6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4cbb6c",
  null
  
)

export default component.exports